<script>
export default {
  name: 'customeCheckBox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<template>
  <div class="custom-checkbox">
    <label class="custom-checkbox__wrap">
      <input type="checkbox" :name="name" :checked="checked" v-model="model" />
      <span>
        <slot />
      </span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
@import 'checkbox.scss';
</style>
